var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{staticClass:"page-header"}),_c('router-view',{key:_vm.$route.fullPath,staticClass:"page-main"}),(!_vm.isHeadFooterShow)?[_c('Footer',{staticClass:"page-footer"}),_c('consulting-Services',{staticClass:"page-service"})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }